export { default } from './DiscountLockBenefits';
